import React from 'react'

export default function Year() {
    const year = new Date().getFullYear()
    return (
        <>{year}</>
    )
}
